"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
export default function FAQ() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const faqItems = [{
    id: "item-1",
    question: "What areas does Phoenix Enterprise TCP serve?",
    answer: "We provide luxury chauffeur services throughout Los Angeles and surrounding areas in Southern California, including all major airports, business districts, and event venues."
  }, {
    id: "item-2",
    question: "How do I make a reservation?",
    answer: "You can book our services by calling or texting 323-492-6292, or by emailing phoenixenerprises@gmail.com. We recommend booking in advance for guaranteed availability, especially for airport transfers and special events."
  }, {
    id: "item-3",
    question: "What types of vehicles are available?",
    answer: "Our fleet consists of high-end luxury sedans and SUVs, meticulously maintained to ensure comfort, safety, and style. All vehicles feature premium interiors and are regularly detailed for your satisfaction."
  }, {
    id: "item-4",
    question: "Are your chauffeurs professionally trained?",
    answer: "Yes, all our chauffeurs are experienced, professional drivers who prioritize punctuality, discretion, and exceptional service. They are fully licensed, insured, and trained in luxury transportation standards."
  }, {
    id: "item-5",
    question: "Do you offer 24/7 availability?",
    answer: "Absolutely. Phoenix Enterprise TCP operates 24/7 to accommodate early morning flights, late-night arrivals, and any time-sensitive transportation needs you may have."
  }, {
    id: "item-6",
    question: "What is your cancellation policy?",
    answer: "We understand plans can change. Please contact us as soon as possible if you need to modify or cancel your reservation. Our team will work with you to accommodate your needs and discuss any applicable policies."
  }];
  return <section id="faq" className="dark bg-background text-foreground section-padding relative overflow-hidden" ref={sectionRef}>
      {}
      <div className="fixed bottom-8 right-8 opacity-5 pointer-events-none z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/phoenix_watermark_logo.png" alt="" className="w-32 h-32 object-contain" />
      </div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl relative z-10">
        {}
        <div className={`text-center mb-12 transition-all duration-[var(--duration-slow)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">
            Find answers to common questions about our luxury chauffeur services
          </p>
        </div>

        {}
        <div className={`glass-effect p-6 md:p-8 lg:p-10 transition-all duration-[var(--duration-slow)] delay-150 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => <AccordionItem key={item.id} value={item.id} data-index={index} className="border-b border-white/10 last:border-b-0">
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold hover:text-secondary transition-colors duration-[var(--duration-medium)]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        {}
        <div className={`text-center mt-12 transition-all duration-[var(--duration-slow)] delay-300 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <p className="text-muted-foreground mb-6">
            Still have questions? We're here to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="tel:323-492-6292" className="btn-primary hover-lift">
              Call 323-492-6292
            </Link>
            <Link to="mailto:phoenixenerprises@gmail.com" className="btn-secondary hover-lift">
              Email Us
            </Link>
          </div>
        </div>
      </div>
    </section>;
}